var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[_c('img',{attrs:{"alt":_vm.alt,"src":_vm.Logo}})])}
var staticRenderFns = []

export { render, staticRenderFns }